import { IEntity } from '@infodata-group/inf-commons';

export class AbsenceTypeGroup implements IEntity {
  public id: string;
  public label: string;
  public color: string;
  public borderColor: string;
  public absenceType: string[];
  lock: boolean;

  constructor(
    id: string,
    label: string,
    color: string,
    borderColor: string,
    absenceType: string[],
  ) {
    this.id = id;
    this.label = label;
    this.color = color;
    this.borderColor = borderColor;
    this.absenceType = absenceType;
  }

  getId(): string {
    return this.id;
  }

  getLabel(): string {
    return this.label;
  }
  toString() {
    return `${this.label}`;
  }

  serialize(): any {
    throw new Error('Not implemented');
  }
}
